import React, { Component } from 'react';
import '../static/css/bootstrap.min.css'
import '../index.css'
import image1 from '../resources/p6_img1.svg'
import image2 from '../resources/p6_img2.svg'
import image3 from '../resources/p6_img3.svg'


class Section6 extends Component {
  render() {
    return (
      <section id="page_6">
        <div className="container">
          <div className="row">
            <div className="title col-sm-offset-0 col-xs-offset-1">
              Musioを導入することで、<br/>
              こんなメリットが期待されます
            </div>
          </div>

          <div className="row">
            <div className="info_image">
              <div className="col-sm-offset-0 col-sm-4 col-xs-offset-1 col-xs-10">
                <img src={image1} alt='image1'/>
                <div className="text-center sub_title">
                  短期間でMusio費用が回収可能
                </div>
                <div className="content">
                  Musio料として、毎月の授業料に2000円追加することで、Musio費用が半年以内に回収が可能です。
                  Musio料は独自で設定していただくため、授業に合った値段設定を行ってください。
                </div>
              </div>
              <div className="col-sm-offset-0 col-sm-4 col-xs-offset-1 col-xs-10">
                <img src={image2} alt='image2'/>
                <div className="text-center sub_title">
                   Musio導入で、入塾率15％UP
                </div>
                <div className="content">
                  すでにMusioを導入している教室では、2016年度から2017年度にかけて、入塾率が最高18％上昇しています。
                  生徒たちからも「楽しかった！」というアンケート結果が多く、生徒のモチベーションにつながっています。*
                </div>
              </div>
              <div className="col-sm-offset-0 col-sm-4 col-xs-offset-1 col-xs-10">
                <img src={image3} alt='image3'/>
                <div className="text-center sub_title">
                  継続性があり、長期的に利用
                </div>
                <div className="content">
                  充実したコンテンツ、独自のカリキュラム作成、生徒管理などの機能により、授業の継続性が見込まれ、長期的に利用できます。
                  サポート体制も整っているので、ご不明点はご連絡ください。
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="comment">
              * Source: 成基の英語学童GKCアンケート調査（鳥丸二条教室、草津教室. 2017 実施）
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default Section6;



// WEBPACK FOOTER //
// ./src/sections/Section6.js